import { Routes } from '@angular/router';
import { authRoutes } from '@auth/auth.routes';
import { accountRedirectGuard } from '@core/guards/account-redirect.guard';
import { staffGuard } from '@core/guards/role.guard';
import { tenantAccessGuard, tenantLegacyRedirectGuard } from '@core/guards/tenant-access.guard';
import { tenantIdMatcher } from '@core/tenant/tenant-url';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'tenant',
  },
  ...authRoutes,
  {
    path: 'account',
    canActivate: [accountRedirectGuard],
    loadChildren: () => import('@account/account.routes').then((m) => m.accountRoutes),
  },

  {
    path: 'admin',
    canActivate: [staffGuard],
    loadChildren: () => import('@admin/admin.routes').then((m) => m.adminRoutes),
  },

  {
    path: 'tenant',
    children: [
      {
        matcher: tenantIdMatcher,
        canActivate: [tenantAccessGuard],
        loadChildren: () => import('@tenant/tenant.routes').then((m) => m.tenantRoutes),
      },
      {
        path: '**',
        canActivate: [tenantLegacyRedirectGuard],
        children: [],
      },
    ],
  },

  {
    path: '**',
    redirectTo: 'tenant',
  },
];
